const sports = [
  {
    id: 'pickleball',
    name: 'Pickleball',
    description: 'A dynamic mix of tennis and squash, played in doubles on an enclosed court with walls that keep the ball in play.',
    icon: 'IconBallTennis',
    color: '#00d4ff'
  },
  {
    id: 'tennis',
    name: 'Tennis',
    description: 'Classic racquet sport played on a rectangular court with a net.',
    icon: 'IconBallTennis',
    color: '#ffd700'
  },
  {
    id: 'soccer',
    name: 'Soccer',
    description: 'The world\'s most popular sport, played with 11 players per team.',
    icon: 'IconBallFootball',
    color: '#c0c0c0'
  },
  {
    id: 'basketball',
    name: 'Basketball',
    description: 'Fast-paced team sport played on a court with hoops at each end.',
    icon: 'IconBallBasketball',
    color: '#e74c3c'
  },
  {
    id: 'volleyball',
    name: 'Volleyball',
    description: 'Team sport where players hit a ball over a net to score points.',
    icon: 'IconBallVolleyball',
    color: '#00d4ff'
  },
  {
    id: 'padel',
    name: 'Padel',
    description: 'Racquet sport combining elements of tennis and squash, played in doubles.',
    icon: 'IconBallTennis',
    color: '#ffd700'
  },
  {
    id: 'badminton',
    name: 'Badminton',
    description: 'Racquet sport played with a shuttlecock over a high net.',
    icon: 'IconBallTennis',
    color: '#c0c0c0'
  },
  {
    id: 'squash',
    name: 'Squash',
    description: 'Indoor racquet sport played in a four-walled court with a small rubber ball.',
    icon: 'IconBallTennis',
    color: '#e74c3c'
  }
];

export default sports;
